/**
 * SDZ Pulse — storefront chat assistant (FAQ + backend LLM).
 * Injected via layout/theme.liquid as sdz-pulse-chat.js
 */
(function () {
  if (typeof document === "undefined") return;
  if (window.__sdzPulseChatMounted) return;
  window.__sdzPulseChatMounted = true;

  const API =
    (window.SDZ_PULSE_CHAT_API ||
      "https://api.sdzautomation.com/api/v1/affiliate/public/chat").replace(/\/+$/, "");

  const css = `
#sdz-pulse-chat-root{all:initial;position:fixed;z-index:2147483000;right:18px;bottom:18px;font-family:"Segoe UI",system-ui,sans-serif;color:#f4f1ec}
#sdz-pulse-chat-root *{box-sizing:border-box}
#sdz-pulse-chat-launcher{
  width:54px;height:54px;border-radius:999px;border:1px solid rgba(244,241,236,.18);
  background:linear-gradient(160deg,#1a1a1a 0%,#0c0c0c 70%);
  color:#f4f1ec;cursor:pointer;box-shadow:0 10px 28px rgba(0,0,0,.45);
  display:grid;place-items:center;transition:transform .2s ease, opacity .2s ease;
}
#sdz-pulse-chat-launcher:hover{transform:translateY(-1px)}
#sdz-pulse-chat-launcher svg{width:22px;height:22px;fill:none;stroke:currentColor;stroke-width:1.7}
#sdz-pulse-chat-panel{
  display:none;position:absolute;right:0;bottom:66px;width:min(360px,calc(100vw - 28px));
  height:min(520px,calc(100vh - 110px));border-radius:18px;overflow:hidden;
  border:1px solid rgba(244,241,236,.12);
  background:linear-gradient(180deg,#141414 0%,#0a0a0a 100%);
  box-shadow:0 24px 60px rgba(0,0,0,.55);flex-direction:column;
}
#sdz-pulse-chat-panel.open{display:flex}
#sdz-pulse-chat-head{
  padding:14px 16px;border-bottom:1px solid rgba(244,241,236,.08);
  display:flex;align-items:center;justify-content:space-between;gap:12px;
}
#sdz-pulse-chat-head strong{font-size:14px;letter-spacing:.04em;font-weight:600}
#sdz-pulse-chat-head span{display:block;font-size:11px;color:rgba(244,241,236,.55);margin-top:2px}
#sdz-pulse-chat-close{
  border:0;background:transparent;color:rgba(244,241,236,.7);cursor:pointer;font-size:20px;line-height:1;padding:4px
}
#sdz-pulse-chat-msgs{flex:1;overflow:auto;padding:14px 14px 8px;display:flex;flex-direction:column;gap:10px}
.sdz-chat-bubble{
  max-width:88%;padding:10px 12px;border-radius:14px;font-size:13px;line-height:1.45;white-space:pre-wrap
}
.sdz-chat-bubble.bot{align-self:flex-start;background:rgba(255,255,255,.06);color:#f4f1ec}
.sdz-chat-bubble.user{align-self:flex-end;background:#8b1e1e;color:#fff}
#sdz-pulse-chat-form{
  display:flex;gap:8px;padding:12px;border-top:1px solid rgba(244,241,236,.08);background:rgba(0,0,0,.25)
}
#sdz-pulse-chat-form input[type=text]{
  flex:1;border-radius:12px;border:1px solid rgba(244,241,236,.14);background:#111;color:#f4f1ec;
  padding:11px 12px;font-size:13px;outline:none
}
#sdz-pulse-chat-form button[type=submit]{
  border:0;border-radius:12px;background:#8b1e1e;color:#fff;padding:0 14px;font-size:13px;cursor:pointer;font-weight:600
}
#sdz-pulse-chat-form button[type=submit]:disabled{opacity:.5;cursor:wait}
#sdz-pulse-chat-hp{position:absolute;left:-9999px;opacity:0;height:0;width:0}
@media (max-width:480px){
  #sdz-pulse-chat-root{right:12px;bottom:12px}
  #sdz-pulse-chat-panel{width:calc(100vw - 24px);height:min(70vh,560px)}
}
`;

  function el(tag, attrs, html) {
    const node = document.createElement(tag);
    if (attrs) Object.entries(attrs).forEach(([k, v]) => node.setAttribute(k, v));
    if (html != null) node.innerHTML = html;
    return node;
  }

  function addBubble(msgs, text, who) {
    const b = el("div", { class: `sdz-chat-bubble ${who}` });
    b.textContent = text;
    msgs.appendChild(b);
    msgs.scrollTop = msgs.scrollHeight;
  }

  function mount() {
    const style = el("style", { id: "sdz-pulse-chat-style" });
    style.textContent = css;
    document.head.appendChild(style);

    const root = el("div", { id: "sdz-pulse-chat-root", "aria-live": "polite" });
    const launcher = el(
      "button",
      {
        id: "sdz-pulse-chat-launcher",
        type: "button",
        "aria-label": "Open Pulse chat",
        title: "Chat with Pulse",
      },
      '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 5.5A2.5 2.5 0 0 1 6.5 3h11A2.5 2.5 0 0 1 20 5.5v8A2.5 2.5 0 0 1 17.5 16H10l-4.2 3.2c-.7.5-1.8 0-1.8-.9V5.5Z"/></svg>'
    );

    const panel = el("div", { id: "sdz-pulse-chat-panel", role: "dialog", "aria-label": "Pulse assistant" });
    panel.innerHTML =
      '<div id="sdz-pulse-chat-head"><div><strong>Pulse</strong><span>Shipping · sizing · store help</span></div>' +
      '<button id="sdz-pulse-chat-close" type="button" aria-label="Close">×</button></div>' +
      '<div id="sdz-pulse-chat-msgs"></div>' +
      '<form id="sdz-pulse-chat-form">' +
      '<input id="sdz-pulse-chat-hp" name="website" tabindex="-1" autocomplete="off" />' +
      '<input id="sdz-pulse-chat-input" type="text" name="message" maxlength="1000" placeholder="Ask about shipping, sizing…" required autocomplete="off" />' +
      '<button type="submit">Send</button></form>';

    root.appendChild(panel);
    root.appendChild(launcher);
    document.body.appendChild(root);

    const msgs = panel.querySelector("#sdz-pulse-chat-msgs");
    const form = panel.querySelector("#sdz-pulse-chat-form");
    const input = panel.querySelector("#sdz-pulse-chat-input");
    const hp = panel.querySelector("#sdz-pulse-chat-hp");
    const closeBtn = panel.querySelector("#sdz-pulse-chat-close");

    addBubble(
      msgs,
      "Ask about products, sizing, shipping, or this page.",
      "bot"
    );

    const setOpen = (open) => {
      panel.classList.toggle("open", open);
      launcher.setAttribute("aria-expanded", open ? "true" : "false");
      if (open) setTimeout(() => input.focus(), 50);
    };

    launcher.addEventListener("click", () => setOpen(!panel.classList.contains("open")));
    closeBtn.addEventListener("click", () => setOpen(false));

    form.addEventListener("submit", async (e) => {
      e.preventDefault();
      const message = (input.value || "").trim();
      if (!message) return;
      addBubble(msgs, message, "user");
      input.value = "";
      const btn = form.querySelector('button[type="submit"]');
      btn.disabled = true;
      try {
        const res = await fetch(API, {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({
            message,
            website: hp.value || "",
            pageUrl: location.href,
          }),
        });
        const json = await res.json().catch(() => ({}));
        if (!res.ok) {
          addBubble(msgs, json.error || "Couldn't reach Pulse — email pulse@sdzautomation.com.", "bot");
        } else {
          addBubble(msgs, (json.data && json.data.reply) || "Got it.", "bot");
        }
      } catch {
        addBubble(msgs, "Connection issue. Email pulse@sdzautomation.com and we'll help.", "bot");
      } finally {
        btn.disabled = false;
        input.focus();
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", mount);
  } else {
    mount();
  }
})();
